import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  :root {
    --container-padding-x: 5%;
    --section-spacing: 4rem;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Poppins', sans-serif;
  }

  html {
    font-size: 16px;
    scroll-behavior: smooth;

    @media (max-width: 768px) {
      font-size: 14px;
    }

    @media (max-width: 480px) {
      font-size: 12px;
    }
  }

  body {
    background-color: ${props => props.theme.colors.background};
    color: ${props => props.theme.colors.text};
    line-height: 1.6;
    overflow-x: hidden;
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 var(--container-padding-x);
  }

  section {
    padding: var(--section-spacing) 0;

    @media (max-width: 768px) {
      padding: calc(var(--section-spacing) * 0.75) 0;
    }

    @media (max-width: 480px) {
      padding: calc(var(--section-spacing) * 0.5) 0;
    }
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    font-size: inherit;
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  /* Responsive Grid System */
  .grid {
    display: grid;
    gap: 2rem;
    
    &.grid-2 {
      grid-template-columns: repeat(2, 1fr);
      
      @media (max-width: 768px) {
        grid-template-columns: 1fr;
      }
    }
    
    &.grid-3 {
      grid-template-columns: repeat(3, 1fr);
      
      @media (max-width: 992px) {
        grid-template-columns: repeat(2, 1fr);
      }
      
      @media (max-width: 576px) {
        grid-template-columns: 1fr;
      }
    }
    
    &.grid-4 {
      grid-template-columns: repeat(4, 1fr);
      
      @media (max-width: 1200px) {
        grid-template-columns: repeat(3, 1fr);
      }
      
      @media (max-width: 992px) {
        grid-template-columns: repeat(2, 1fr);
      }
      
      @media (max-width: 576px) {
        grid-template-columns: 1fr;
      }
    }
  }

  /* Flexbox Utilities */
  .flex {
    display: flex;
    
    &.flex-wrap {
      flex-wrap: wrap;
    }
    
    &.flex-column {
      flex-direction: column;
    }
    
    @media (max-width: 768px) {
      &.flex-column-mobile {
        flex-direction: column;
      }
    }
  }
`;

export default GlobalStyle;
